module.exports = __webpack_public_path__ + "static/img/im.8c10222d.svg";